import { Component, Input } from '@angular/core';
import { ComponentWithCopy } from '../../intefaces/interfaces';
import { BodyLarge } from '../../components/typography/body-large/body-large';
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large';
import { Link } from '../../components/link/link';
import { AnimateOnScroll } from 'primeng/animateonscroll';


@Component({
  selector: 'app-feature-2-columns-with-icon-line',
  imports: [HeadlineLarge, BodyLarge, Link, AnimateOnScroll],
  templateUrl: './feature-2-columns-with-icon-line.html',
  styleUrl: './feature-2-columns-with-icon-line.css'
})
export class Feature2ColumnsWithIconLine {
  	@Input() content!: ComponentWithCopy

}
